<template>
    <div class="roothome_m">

        <div class="wrapper">
            <!-- Sidebar Holder -->
            <nav id="sidebar">
                <div id="dismiss">
                    <!--<img src="/static/imgs/ic_menu.png" alt="menu" class="im_menu1">-->
                </div>

                <div class="sidebar-header" style="font-size: 1.1em; height: 36%;">
                    <br>
                    <br>
                    <router-link to="mHome">
                        <img src="/static/imgs/advice_b_horizontal.png" alt="menu" style="width: 60%">
                    </router-link>
                    <br>
                    <br>
                    <span v-if="user.idioma==0" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; margin-right:10px; font-weight: bold;">Português</span>
                    <span v-if="user.idioma!=0" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; margin-right:10px; " @click="changeIdioma(0)">Português</span>
                    <span v-if="user.idioma==1" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; margin-right:10px; font-weight: bold;">English</span>
                    <span v-if="user.idioma!=1" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; margin-right:10px; " @click="changeIdioma(1)">English</span>
                    <span v-if="user.idioma==2" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; font-weight: bold;">Español</span>
                    <span v-if="user.idioma!=2" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt;" @click="changeIdioma(2)">Español</span>
                    <br>
                    <br>

                    <div style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                        <div class="div_botao_t_b" @click="setShowLogin(true)" onMouseOver="this.style.cursor='pointer'">
                            <span class="tx_continuar"> {{ getInterText(inter_ind.entrar) }} </span>
                        </div>

                        <router-link to="mRegisterUser" style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                            <div class="div_botao_t_w">
                                <span class="tx_continuar"> {{ getInterText(inter_ind.cadastre) }} </span>
                            </div>
                        </router-link>
                    </div>
                </div>

                <ul class="list-unstyled components" style="height: 56%; overflow-y: scroll;">
                    <li class="active">
                        <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu">{{ getInterText(inter_ind.categorias) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu" >
                            <li v-for="item in cats_full">
                                <router-link :to="{ query: { idCat: item.id }, params: { stabs: estabs_full, categs: cats_full}, name: 'mHome'}">
                                    <a href="#"><img v-if="item.imgPath2!=null" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" class="im_cat_min">{{ item.nome }}</a>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a href="#">{{ getInterText(inter_ind.quem_somos) }}</a>
                    </li>
                    <li @click="atualizaEstabs(-2, true)">
                        <a href="#">{{ getInterText(inter_ind.os) }} 10+</a>
                    </li>
                    <li>
                        <a href="#">{{ getInterText(inter_ind.contato) }}</a>
                    </li>
                    <li class="active">
                        <a href="#pageSubmenu2" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu2">{{ getInterText(inter_ind.telefones_uteis) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu2">
                            <li v-for="item in telefoneUteis">
                                <a :href="'tel:' + trimAll(item.tel)" style="margin-left: 5px">{{ getInterText(item.nome) }}: {{ item.tel }}</a>
                            </li>
                        </ul>
                    </li>
                </ul>

                <!-- PARCEIROS -->
                <div class="div_pat_m">
                    <hr class="hr_pat"/>
                    <!--<span class="tx_parceiros">PARCEIROS</span><br>-->
                    <a v-for="item in barra_pat" :href="item.url" target="_blank"><img :src="item.imgPathW" class="im_pat_m"/></a>
                </div>

            </nav>


            <!--<div class="section" id="sidebarCollapse" @click="changeSideBar()">-->
                <!--<a class="navicon-button x" id="icmenu" >-->
                    <!--<div class="navicon">-->
                    <!--</div>-->
                <!--</a>-->
            <!--</div>-->

            <div>
                <!-- ################    Top Menu Bar    ################# -->
                <div align="center" class="head0" style="box-shadow: 0px 3px 10px var(--font-dark-gray);">
                    <div align="center" class="head0_2m">
                        <div class="head1m">
                            <img src="/static/imgs/ic_back_w.png" alt="menu" class="im_menu2" @click="goToBack()" onMouseOver="this.style.cursor='pointer'">
                            <!--<img src="/static/imgs/ic_menu.png" alt="menu" class="im_menu2" id="sidebarCollapse">-->
                            <!--<a href="#" onclick="history.go(-1)"><img src="/static/imgs/ic_back.png" class="im_menu3"></a>-->
                        </div><div class="head2m">



                        <router-link :to="{ params: { stabs: estabs_full, categs: cats_full}, name: 'mHome'}">
                            <span class="tx_logol" > {{ titlePage }}</span>
                            <!--<img src="/static/imgs/advicep_horizontal2_small.png" alt="Logo Advice" class="im_logol">-->
                        </router-link>
                    </div><div  class="head3m">
                        <router-link v-if="!user.sucess" to="mRegisterUser">
                            <div class="di_profile">
                                <img src="/static/imgs/ic_perfil.png" alt="profile" class="im_profile">
                            </div>
                        </router-link>
                        <div v-else class="di_profile" @click="showPopEscritorio()">
                            <div v-if='user.foto === ""' class="im_profile_m2" style="justify-content: center; align-items: center; background-color: var(--bg-blue)">
                                <span class="tx_initials" >{{ getInitials(user) }}</span>
                            </div>
                            <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile_2">
                            <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im_profile_2">
                        </div>
                        <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                            <div class="arrow_top"></div>
                            <span class="tx_login_b" >{{ getFirstAndLastWords(user.nome) }}</span>
                            <router-link class="tx_login" to="mMinhaPagina">
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.minha_conta) }}</span>
                            </router-link>
                            <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('mEditUser')">{{ getInterText(inter_ind.configuracoes) }}</span>
                            <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                        </div>
                    </div>
                        <!-- ################    Degrade    ################# -->
                        <!--<div class="title0">-->
                            <!--<img src="/static/imgs/bg_degrade.png" alt="degrade" class="im_degrade">-->
                        <!--</div>-->
                    </div>
                </div>




                <!-- ################    Fotos Estabelecimento   ################# -->
                <div id="photo_cont" style="display: flex; flex-direction: row; background-color: white; margin-top: calc(var(--top-bar-heigth)*1.01); overflow-x: scroll;">
                <!--<div id="photo_cont" style="display: flex; flex-direction: row; background-color:

 white; margin-top: 65px; overflow-x: scroll;">-->
                    <!--<input style="display: none" ref="inputImage" type="file" @change="onFileSelectedMany" multiple="multiple"/>-->
                    <input style="display: none" ref="inputImage" type="file" accept="image/*" @change="onFileSelectedMany" multiple/>
                    <div class="di_photo0" onMouseOver="this.style.cursor='pointer'" @click="$refs.inputImage.click()">
                        <img src="/static/imgs/ic_camera.png" alt="profile" class="im_photos0">
                        <span class="tx_inserir">{{ getInterText(inter_ind.inserir_foto) }}</span>
                        <span class="tx_form_whiteb_sub2" style="font-size: 1.6vh; text-align: center; margin-top: 1.55vh"> Adicione até {{ qMaxFotos }} fotos</span>
                    </div>
                    <!--Animação-->
                    <!--https://codepen.io/dslanger/pen/KqdvMO-->
                    <!--https://stackoverflow.com/questions/26807610/css-only-animate-draw-circle-with-border-radius-and-transparent-background-->
                    <div v-for="(item, index) in photos.slice().reverse()" class="di_photo">
                        <div style="display: flex; position: relative;">
                            <img v-if="!item.uploaded" src="/static/imgs/circle_insta3.png" alt="profile" class="im_photos_back">
                            <img v-else  :src="transpGif" alt="profile" class="im_photos_back_s">

                            <img v-if="item.data != null" :src="item.data" alt="profile" class="im_photos">
                            <img v-else :src="baseUrlImg + 'MARCADOR/' + item.file" alt="profile" class="im_photos">

                            <img src="/static/imgs/bt_erase.png" alt="profile" class="im_fechar" @click="removePhoto(photos.length - 1 - index)">
                        </div>
                        <div style="display: flex; justify-content: center; align-items: center; margin-top: 0.5vh;" @click="changeDestaque(index, 'photo_cont')">
                            <input type="checkbox" :value="index" style="margin-right: 0.6vw; margin-top: 0;" :checked="item.destaque">
                            <span style="font-size: 1.7vh;">Destaque</span>
                        </div>
                    </div>
                </div>

                <!-- ################    Form    ################# -->
                <div style="display: flex; flex-direction: column; margin-top: 2%;">
                    <div class="di_form_item" v-for="(item, index) in editing" v-if="index < 2">
                        <div class="div_nome">
                            <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                            </div>
                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index != 1" tabindex="1"/>
                            <textarea :id="item.id" name="message" style="border: none; width: 100%; border-color: Transparent; overflow: auto; outline: none; font-size: 15pt; height: 300px;" rows="10" cols="30" v-model="item.texto" v-if="item.status && index == 1"></textarea>
                        </div>
                        <div v-html="displayFormattedText(item.texto)" v-if="!item.status && index == 1"></div>
                    </div>




                    <!--Video Link-->
                    <div class="di_form_item">
                        <div class="div_nome">
                            <div @click="clickInput2_2(14)" onMouseOver="this.style.cursor='pointer'">
                                <span class="tx_form_grayb" v-if="!editing[14].status">{{ editing[14].campo }}</span>
                                <span class="tx_form" v-if="editing[14].status">{{ editing[14].campo }}</span>
                            </div>
                            <input :id="editing[14].id" class="input_name_m2" type="text" v-model="editing[14].texto" v-if="editing[14].status" tabindex="14"/>
                        </div>
                        <div>
                            <iframe v-if="isYouTubeLink(editing[14].texto)" width="100%" height="150" :src="'https://www.youtube.com/embed/' + getYoutubeCode(editing[14].texto)" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                            <!--<iframe src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fadviceparaiba%2Fvideos%2F523508688327109%2F&show_text=false&width=560" width="100%" height="314" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>-->
                        </div>
                    </div>



                    <!-- ################    Categorias    ################# -->
                    <div v-if="showCats" class="di_form_item_s" @click="showCategorias()" onMouseOver="this.style.cursor='pointer'">
                        <span class="tx_form_whiteb" >{{ getInterText(inter_ind.categorias) }}</span>
                    </div>
                    <div v-else class="di_form_item" @click="showCategorias()" onMouseOver="this.style.cursor='pointer'">
                        <span class="tx_form_grayb" >{{ getInterText(inter_ind.categorias) }}</span>
                    </div>
                    <div class="di_form_item_c" v-if="showCats" onMouseOver="this.style.cursor='pointer'">
                        <div class="di_form_item_c2" v-for="(item, index) in cats_full" v-if="(cats_full[index].apareceListagem || user.tipo >= 1) && index > 0" @click="selectCat(index)">

                            <div class="di_form_item2_b" v-if="cats_full[index].deleted">
                                <img v-if="item.imgPath2!=null" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" class="im_cat_min2">
                                <span class="tx_form_white">{{ getInterCatName(item) }}</span>
                            </div>
                            <div class="di_form_item2" v-if="!cats_full[index].deleted">
                                <img v-if="item.imgPath2!=null" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" class="im_cat_min2_gray">
                                <span class="tx_form_gray">{{ getInterCatName(item) }}</span>
                            </div>

                        </div>
                    </div>


                    <div class="di_form_item" v-for="(item, index) in editing" v-if="index == 15 && hasSubCats()">
                        <div class="div_nome">
                            <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                            </div>
                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status" tabindex="1"/>
                        </div>
                    </div>


                    <div class="di_form_item" v-for="(item, index) in editing" v-if="index == 2">
                        <div class="div_nome">
                            <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                            </div>
                            <!--<input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status" tabindex="1"/>-->
                            <textarea :id="item.id" name="message" style="border: none; width: 500%; border-color: Transparent; overflow: auto; outline: none; font-size: 15pt;" rows="2" cols="30" v-model="item.texto" v-if="item.status"></textarea>
                            <!--<span v-if="!checkName(editing[0].texto) && editing[0].texto!=''" class="error_msg">Nome inválido.</span>-->
                        </div>
                    </div>

                    <div class="di_form_item" v-for="(item, index) in editing" v-if="index == 3">
                        <div class="div_nome">
                            <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                               

 <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                                <img src="/static/imgs/loading4.gif" class="im_loading_cep" v-if="loadingCep">
                                <span class="tx_form_small" @click="showAddress = !showAddress;" v-html="showAddress ? getInterText(inter_ind.esconder_endereco) : getInterText(inter_ind.digitar_endereco)"></span>
                            </div>
                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status" tabindex="1" v-on:keyup="verificaCEP(item.texto)"/>
                            <span v-if="(item.texto.length >= 8) && item.texto!='' && !cepOk" class="error_msg">{{ getInterText(inter_ind.cep_nao) }}</span>
                        </div>
                    </div>

                    <div class="di_form_item" v-for="(item, index) in editing" v-if="showAddress && index >= 4 && index <= 9">
                        <div class="div_nome">
                            <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                                <img src="/static/imgs/loading4.gif" class="im_loading_cep" v-if="loadingCep">
                            </div>
                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status" tabindex="1"/>
                        </div>
                    </div>


                    <div class="di_form_item" v-for="(item, index) in editing" v-if="index >= 10 && index <= 13 && (index != 12 || (hasCatsSiteVenda() && user.tipo >= 1))">
                        <div class="div_nome">
                            <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                            </div>
                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index == 10" tabindex="1" v-on:keyup="mphone(item)"/>
                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index != 10" tabindex="1"/>
                            <span v-if="index == 13 && !checkEmail(item.texto) && item.texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                        </div>
                    </div>

                </div>

                <!-- ################    TRAJE    ################# -->
                <!--<div style="display: flex; flex-direction: row; padding-left: 5.5%;">-->
                    <!--<span class="tx_form2">{{ getInterText(inter_ind.traje) }}</span>-->
                    <!--<div style="display: flex; flex-direction: row;">-->
                        <!--<div class="di_photo_traje" @click="clickTraje(0)">-->
                            <!--<span class="tx_form3">{{ getInterText(traje[0].texto) }}</span>-->
                            <!--<div v-if="!traje[0].status" class="dv_traje2">-->
                                <!--<img src="/static/imgs/t_praia.png" alt="profile" class="im_traje2">-->
                            <!--</div>-->
                            <!--<div v-else class="dv_traje2_s">-->
                                <!--<img src="/static/imgs/t_praia.png" alt="profile" class="im_traje2_s">-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="di_photo_traje" @click="clickTraje(1)">-->
                            <!--<span class="tx_form3">{{ getInterText(traje[1].texto) }}</span>-->
                            <!--<div v-if="!traje[1].status" class="dv_traje2">-->
                                <!--<img src="/static/imgs/t_sport.png" alt="profile" class="im_traje2">-->
                            <!--</div>-->
                            <!--<div v-else class="dv_traje2_s">-->
                                <!--<img src="/static/imgs/t_sport.png" alt="profile" class="im_traje2_s">-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="di_photo_traje" @click="clickTraje(2)">-->
                            <!--<span class="tx_form3">{{ getInterText(traje[2].texto) }}</span>-->
                            <!--<div v-if="!traje[2].status" class="dv_traje2">-->
                                <!--<img src="/static/imgs/t_formal.png" alt="profile" class="im_traje2">-->
                            <!--</div>-->
                            <!--<div v-else class="dv_traje2_s">-->
                                <!--<img src="/static/imgs/t_formal.png" alt="profile" class="im_traje2_s">-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->


                <!-- ################    Ticket Medio    ################# -->
                <div style="display: flex; flex-direction: row; padding-left: 5.5%; margin-top: 2vh; margin-bottom: 5vh">
                    <span class="tx_form2">{{ getInterText(inter_ind.ticket_medio) }}</span>
                    <div style="display: flex; flex-direction: column;">
                        <div style="display: flex; flex-direction: row; justify-content: space-between;">
                            <div class="di_photo_ticket">
                                <span class="tx_form3">$20</span>
                            </div>
                            <div class="di_photo_ticket">
                                <span class="tx_form3">&nbsp;</span>
                            </div>
                            <div class="di_photo_ticket">
                                <span class="tx_form3">$40</span>
                            </div>
                            <div class="di_photo_ticket">
                                <span class="tx_form3">&nbsp;</span>
                            </div>
                            <div class="di_photo_ticket">
                                <span class="tx_form3">$60</span>
                            </div>
                            <div class="di_photo_ticket">
                                <span class="tx_form3">&nbsp;</span>
                            </div>
                            <div class="di_photo_ticket">
                                <span class="tx_form3">&nbsp;</span>
                            </div>
                            <div class="di_photo_ticket">
                                <span class="tx_form3">$100+</span>
                            </div>
                        </div>
                        <div style="display: flex; flex-direction: row; padding-right: 0px;">
                            <div class="di_photo_ticket" @click="clickTicket(0)">
                                <div class="di_circle" v-if="!ticket[0].status"/>
                                <div class="di_circle_s" v-else/>
                            </div>
                            <div class="di_photo_ticket" @click="clickTicket(1)">
                                <div class="di_circle" v-if="!ticket[1].status"/>
                                <div class="di_circle_s" v-else/>
                            </div>
                            <div class="di_photo_ticket" @click="clickTicket(2)">
                                <div class="di_circle" v-if="!ticket[2].status"/>
                                <div class="di_circle_s" v-else/>
                            </div>
                            <div class="di_photo_ticket" @click="clickTicket(3)">
                                <div class="di_circle" v-if="!ticket[3].status"/>
                                <div class="di_circle_s" v-else/>
                            </div>
                            <div class="di_photo_ticket" @click="clickTicket(4)">
                                <div class="di_circle" v-if="!ticket[4].status"/>
                                <div class="di_circle_s" v-else/>
                            </div>
                            <div class="di_photo_ticket" @click="clickTicket(5)">
                                <div class="di_circle" v-if="!ticket[5].status"/>
                                <div class="di_circle_s" v-else/>
                            </div>
                            <div class="di_photo_ticket" @click="clickTicket(6)">
                                <div class="di_circle" v-if="!ticket[6].status"/>
                                <div class="di_circle_s" v-else/>
                            </div>
                            <div class="di_photo_ticket" @click="clickTicket(7)">
                                <div class="di_circle" v-if="!ticket[7].status"/>
                                <div class="di_circle_s" v-else/>
                            </div>
                        </div>


                    </div>
                </div>

                <span v-for="item in msg_erros" class="error_msg" style="margin-left: 20px;"> * {{ item }} <br/> </span>

                <div style="display: flex; flex-direction: row; justify-content: space-evenly;">

                    <div v-if="(new_estab.id > 0) && (ativo == true)" style="display: flex; justify-content: center; align-items: center; cursor: pointer; width

: 38vw;" @click="setEstabAtivo()">
                        <img src="/static/imgs/ic_option_off.png" alt="desativar" style="width: 3.3vh; height: 3vh; object-fit: contain; flex-grow: 1;">
                        <span style="font-size: 3.7vw; margin-left: 1vh; color: var(--font-dark-gray2); flex-grow: 5;">{{ getInterText(inter_ind.desativar_pagina) }}</span>
                    </div>

                    <div v-if="(new_estab.id > 0) && (ativo == false)" style="display: flex; justify-content: center; align-items: center; cursor: pointer; width: 38vw;" @click="setEstabAtivo()">
                        <img src="/static/imgs/ic_option_on.png" alt="ativar" style="width: 3.3vh; height: 3vh; object-fit: contain; flex-grow: 1">
                        <span style="font-size: 3.7vw; margin-left: 1vh; color: var(--font-dark-gray2); flex-grow: 5;">{{ getInterText(inter_ind.ativar_pagina) }}</span>
                    </div>

                    <div v-if="new_estab.id > 0" style="display: flex; justify-content: center; align-items: center; cursor: pointer;" @click="submitformEstab(false)">
                        <img src="/static/imgs/ic_excluir.png" alt="excluir" style="width: 3.3vh; height: 3vh; object-fit: contain">
                        <span style="font-size: 3.7vw; margin-left: 1vh; color: var(--font-dark-gray2)">{{ getInterText(inter_ind.excluir_pagina) }}</span>
                    </div>

                </div>

                <!-- ################    Botao Enviar    ################# -->
                <div style="margin-top: 2vh; margin-bottom: 5vh; padding: 2vh; background-color: var(--bg-purple); text-align: center" onMouseOver="this.style.cursor='pointer'" @click="submitformEstab(true)">
                    <span style="color: white; font-size: 25pt;">{{ getInterText(inter_ind.enviar) }}</span>
                </div>


            </div>
        </div>

        <div class="div_login_m" v-if="showLogin" >
            <div class="parts_m">
                <div style="display: flex; justify-content: flex-end; width: 100%;" @click="setShowLogin(false)">
                    <img src="/static/imgs/bt_close_c.png" class="im_close_m" onMouseOver="this.style.cursor='pointer'">
                </div>

                <div style="text-align: center;">
                    <span class="tx_login3">{{ getInterText(inter_ind.entrar) }}</span>
                </div>

                <div class="div_nome_l">
                    <span class="tx_nome_before" @click="clickInput3(editingLogin, 1, true)" v-if="!editingLogin[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>
                    <div class="hr" @click="clickInput3(editingLogin, 1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editingLogin[1].status"/>
                    <span class="tx_nome" @click="clickInput3(editingLogin, 1, false)" v-if="editingLogin[1].status">E-mail</span>
                    <input id="emailid" class="input_name_m" type="text" v-model="editingLogin[1].texto" v-if="editingLogin[1].status" tabindex="3"/>
                    <span v-if="!checkEmail(editingLogin[1].texto) && editingLogin[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome_l">
                    <span class="tx_nome_before" @click="clickInput3(editingLogin, 0, true)" v-if="!editingLogin[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>
                    <div class="hr" @click="clickInput3(editingLogin, 0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editingLogin[0].status"/>
                    <span class="tx_nome" @click="clickInput3(editingLogin, 0, false)" v-if="editingLogin[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <input id="nameid" class="input_name_m" type="password" v-model="editingLogin[0].texto" v-if="editingLogin[0].status" tabindex="4"/>
                    <span v-if="!checkPass(editingLogin[0].texto) && editingLogin[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada) }}</span>
                </div>

                <span v-if="senhaErrada" class="error_msg">{{ getInterText(inter_ind.senha_errada_2) }}</span>

                <img v-if="loading.user" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                <div class="div_botao_m" @click="tryLogin2(editingLogin[1].texto, editingLogin[0].texto)" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                    <span class="tx_continuar_w"> {{ getInterText(inter_ind.continuar) }} </span>
                </div>
            </div>
        </div>


        <filter id="colorize" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.18
                 0 0 0 0 0.24
                 0 0 0 0 0.31
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_cinza" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.33
                 0 0 0 0 0.33
                 0 0 0 0 0.33
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_white" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 1
                 0 0 0 0 1
                 0 0 0 0 1
                 0 0 0 1 0"/>
        </filter>


        <Alert v-if="showAlert || showConfirm" :textProp="textAlert" :confirmProp="showConfirm" @emit-close="closeAlert" @emit-action="actionFunction"/>

        <div class="overlay" @click="changeSideBar()"></div>

        <div class="overgalery" @click="showGalery(false)">
            <div class="div_galery" @click.stop.prevent="">
                <img  v-if="estab.tbFotos!=null" :src="baseUrlImg + '/MARCADOR/' + estab.tbFotos[getPhotoIndex(0)].file" alt="Foto Principal" class="imgGalery"/><br>
                <div class="div_arrow_l">
                    <img src="/static/imgs/ic_left_2.png" onmouseover="this.src='/static/imgs/ic_left.png'; this.style.cursor='pointer';" onmouseout="this.src='/static/imgs/ic_left_2.png'" alt="Foto Anterior" @click="nextPhoto(-1)" class="im_arrow">
                </div>
                <div class="div_arrow_r">
                    <img src="/static/imgs/ic_right_2.png" onmouseover="this.src='/static/imgs/ic_right.png'; this.style.cursor='pointer';" onmouseout="this.src='/static/imgs/ic_right_2.png'" alt="Foto Anterior" @click="nextPhoto(+1)" class="im_arrow">
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { advMixin } from '../scripts/advMixin'



    export default {
        mixins: [advMixin],
        name: 'mRegisterEstab',
        data () {
            return {
                ativo: true,
                editing: [
                    {
                        id: 'zeroID',
                        campo: 'Nome da Página',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'umID',
                        campo: 'Descrição',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'doisID',
                        campo: 'Horário Funcionamento',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'tresID',
                        campo: 'CEP',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'quatroID',
                        campo: 'Rua',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'cincoID',
                        campo: 'Número',
                        texto: '',


                        status: false,
                    },
                    {
                        id: 'seisID',
                        campo: 'Complemento',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'seteID',
                        campo: 'Bairro',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'oitoID',
                        campo: 'Cidade',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'novoID',
                        campo: 'Estado',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'dezID',
                        campo: 'Telefone',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'onzeID',
                        campo: 'Web Site',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'dozeID',
                        campo: 'Site Venda',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'trezeID',
                        campo: 'E-mail',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'catorzeID',
                        campo: 'Link Vídeo',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'quinzeID',
                        campo: 'Sub-categoria',
                        texto: '',
                        status: false,
                    }
                ],
                editingLogin: [
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                ],
                ticket: [
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                ],
                estabs: [],
                estab: [],
                estabs_full: [],
                quantCatsSelected: 0,
                cat: {},
                search_text: "",
                photoIndex: 0,
                showShare: false,
                showingSearch: false,
                actualWidth: 0,
                showCats: false,
                cepOk: true,
                showAddress: false,
                loading: {
                    cats: false,
                    estabs: false
                },
                response: {
                    status: "ok"
                },
                // tituloCat: "",
                // corCat: "",
                // corCat2: "#E4E4E4",
                msg_erros: [

                ],
                transpGif: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
            }
        },
        methods: {
            // Ativo vs Desativo
            setEstabAtivo() {
                this.ativo = !this.ativo;
                // console.log('ativo:: ', this.ativo);
            },
            showCategorias() {
                this.showCats = !this.showCats;
            },
            shuffle(array) {
                var tmp, current, top = array.length;
                if(top) while(--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }
                return array;
            },
            handleResize (event) {
                this.actualWidth = window.innerWidth;
                // console.log('window.innerWidth: ' + actualWidth);
            },
            trimAll(str){
                return str.replace(/\s/g,'');
            },
            displayFormattedText(text) {
                if (!text) return '';
                return text.replace(/\n/g, '<br>').replace(/ /g, '&nbsp;');
            },
            convertBreaksToNewlines(text) {
                if (!text) return '';
                return text.replace(/<br>/g, '\n').replace(/&nbsp;/g, ' ');
            },
            loadMessage() {
                fetch('/load-message')
                    .then(response => response.json())
                    .then(data => {
                        this.editing[1].texto = this.decodeChars(data.message);
                        this.forceReRender();
                    });
            },
            forceReRender() {
                this.renderDescription = false;
                this.$nextTick(() => {
                    this.renderDescription = true;
                });
            },
            
            
        },
        created() {
            console.log(name + '::created!!');

            this.new_estab.id = -1;

            this.editing[0].campo = this.getInterText(this.inter_ind.nome_pagina);
            this.editing[1].campo = this.getInterText(this.inter_ind.descricao);
            this.editing[2].campo = this.getInterText(this.inter_ind.horario_funcionamento);
            this.editing[3].campo = this.getInterText(this.inter_ind.cep);
            this.editing[4].campo = this.getInterText(this.inter_ind.rua);
            this.editing[5].campo = this.getInterText(this.inter_ind.numero);
            this.editing[6].campo = this.getInterText(this.inter_ind.complemento);
            this.editing[7].campo = this.getInterText(this.inter_ind.bairro);
            this.editing[8].campo = this.getInterText(this.inter_ind.cidade);
            this.editing[9].campo = this.getInterText(this.inter_ind.estado);
            this.editing[10].campo = this.getInterText(this.inter_ind.telefone);

            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                if (this.$route.params.stab) {
                    console.log('Usando new_estab passados por parametro!!');

                    this.new_estab = this.$route.params.stab;
                    console.log('new_estab: ', this.new_estab);

                    this.ativo = this.new_estab.ativo;

                    this.titlePage = this.getInterText(this.inter_ind.editar_pagina);

                    this.fillFieldsEstab(this.new_estab);
                }
            }
            else {
                console.log('Baixando estabs!!');
                this.getEstabsCats();
            }

            console.log('trajes: ');
            console.log(this.traje);

            console.log('Terminei o created!!');

            this.loadMessage();
        },
        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },
        mounted() {
            console.log('mounted!!');

            this.barra_pat = this.shuffle(this.barra_pat);

            this.initQuantCats();

            console.log('Terminei o mounted!!');
        },
    }
</script>

<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/adv.css" scoped/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .roothome {
        background-color: var(--main-bg-color);
        /*background-color: #E4E4E4;*/
    }
    .title0 {
        /*background-color: red;*/
        text-align: left;
    }
    .head0 {
        position: fixed;
        top: 0;
        z-index: 1;
    }

    #dismiss {
        top: 0;
        left: 0;
        margin-left: 5px;
        margin-top: 10px;
    }

    .di_profile_m {
        padding-top: 7%;
        padding-bottom: 7%;
        margin-right: 5%;
    }

    .im_profile, .im_traje, .im_photos, .im_photos_back {
        display: flex;
        height: 60%;
    }
    .im_profile {
        margin-top: 12px;
    }
    .im_logol, .tx_logol {
        height: 60%;
        vertical-align: middle;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
    .tx_logol {
        color:white;
        font-size: 20pt;
    }
    .im_degrade {
        position: absolute;
        width: 100%;
        height: 12px;
    }
    .im_cat_min, .im_cat_min2, .im_cat_min2_gray {
        width: 17px;
        height: 17px;
        margin-right: 10px;
        object-fit: contain;
    }
    .im_cat_min2, .im_cat_min2_gray {
        width: 40px;
        height: 40px;
    }
    .im_cat_min2_gray {
        filter: url(#colorize_cinza);
    }
    .title {
        display: flex;
        align-items: center;
        justify-content: left;
        background-color: white;
        border-radius:5px;
        margin-right: 2vw;
        margin-left: 2vw;
        margin-bottom: 1vw;
        padding: 2px;
        font-size: 20pt;
    }
    .div_arrow_l, .div_arrow_r {
        position: absolute;
        top:0;
        height: 100%;
        min-width: 40px;
        vertical-align: center;
    }
    .div_arrow_r {
        right: 2px;
    }
    .div_arrow_l {
        left: 2px;
    }
    .im_arrow {
        position: absolute;
        vertical-align: middle;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        padding-top: 30px;
        padding-bottom: 30px;
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -o-transition: all 1s ease;
        -ms-transition: all 1s ease;
        transition: all 1s ease;
    }
    .im_arrow:hover {
        -webkit-filter: brightness(

70%);
        filter: brightness(70%);
    }

    .overgalery {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: rgba(10, 10, 10, 0.85);
        z-index: 1;
        display: none;
        vertical-align: middle;
        top: 0;
    }
    .div_galery {
        vertical-align: middle;
        display: inline-block;
        z-index: 1;
        position: relative;
        top: 50%;
        left: 50%;
        padding-right: 10px;
        padding-left: 10px;
        transform: translate(-50%, -50%);
    }
    .imgGalery {
        width: 95vw;
        object-fit: fill;
    }
    .im_pat {
        height: 1cm;
        margin-left: 0.3cm;
        margin-right: 0.3cm;
        margin-bottom: 0.4cm;
        margin-top: 0.4cm;
    }
    .div_pat {
        position: page;
        bottom: 0;
        display: inline-block;
        /*background-color: #949494;*/
        /*background-color: #B4B4B4;*/
        /*background-color: #C4C4C4;*/
        background-color: #CDCDCD;
        /*background-color: #A6A8AB;*/
        /*background-color: #E4E4E4;*/
        padding-top: 0.25cm;
        padding-bottom: 0.5cm;
        text-align: center;
    }
    .tx_parceiros {;
        font-size: 11pt;
        /*color: #040505;*/
        color: #858585;
    }


    .di_photo, .di_photo_traje, .di_photo_ticket {
        display: inline-block;
        /*background-color: red;*/
        position: relative;
        height: 100%;
        margin: 5px;
    }
    .di_photo {
        /*background-color: var(--bg-blue);*/
        background-size: contain;
        border-radius: 50%;
        padding: 4px;
        position: relative;
    }
    .di_photo_traje {
        margin-right: 3vw;
        /*background: blue;*/
    }
    .di_photo_ticket {
        padding: .3vw;
        margin: .6vw;
    }
    .di_form_item, .di_form_item_s, .di_form_item2, .di_form_item2_b {
        display: flex;
        flex-direction: column;
        background: white;
        border-radius:10px;
        margin-right: 0.5%;
        margin-left: 0.5%;
        margin-bottom: 2%;

        padding-right: 2%;
        padding-left: 5%;
        padding-bottom: 2%;
        padding-top: 2%;
    }

    .di_form_item_s {
        background-image: linear-gradient(var(--bg-blue-grad1), var(--bg-blue-grad2));
        margin-bottom: 1%;
    }

    .di_form_item2, .di_form_item2_b {
        align-items: center;
        flex-direction: row;
        background-color: white;
        width: 100%;
    }
    .di_form_item2_b {
        background-color: var(--bg-blue);
    }

    .di_form_item_c {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 20px;
    }
    .di_form_item_c2 {
        display: flex;
        flex-wrap: wrap;
        flex-grow: 1;
        flex-basis: 40%;
    }

    .im_traje2, .im_traje2_s {
        object-fit: contain;
        width: 100%;
        height: 100%;
    }

    .im_traje2_s {
        filter: url(#colorize_white);
    }

    .dv_traje2, .dv_traje2_s {
        width: 60px;
        height: 60px;
        background-color: white;
        padding-bottom: 9px;
        padding-top: 9px;
        border-radius: 50%;
        box-shadow: 0px 0px 10px #c0c0c0;
    }

    .dv_traje2_s {
        background-color: var(--bg-blue);
    }

    .di_circle, .di_circle_s {
        width: 4vw;
        height: 4vw;
        background: white;
        border-radius: 50%;
        box-shadow: -1px 1px 2px var(--font-dark-gray);
    }
    .di_circle_s {
        background-color: var(--bg-blue);
    }

    .im_photos, .im_photos0, .im_photos_back, .im_photos_back_s {
        width: 90px;
        height: 90px;
        border-radius: 50%;
        object-fit: cover;
    }

    .im_photos, .im_photos_back, .im_photos_back_s {
        width: 86px;
        height: 86px;
        background-color: white;
        position: relative;

    }

    .im_photos {

        margin: 6px;
        margin-left: -80px;
        width: 74px;
        height: 74px;
    }

    .im_photos_back {
        -webkit-animation: rotate 3s infinite linear;
        -moz-animation: rotate 3s infinite linear;
        animation: rotate 3s infinite linear;
    }

    @-moz-keyframes rotate { 100% { -moz-transform: rotate(360deg); } }
    @-webkit-keyframes rotate { 100% { -webkit-transform: rotate(360deg); } }
    @keyframes rotate { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }

    .im_photos_back_s {
        background-color: var(--bg-blue);
    }


    @-webkit-keyframes rotation {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(359deg);
        }
    }

    .di_photo0 {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 5px;
        min-width: 90px;
        width: 90px;
        height: 90px;
        background: #EEE;
        margin-left: 10px;
        border-radius: 50%;
        padding: 10px;
        padding-top: 20px;
        margin-bottom: 4vh;
    }

    .im_photos0 {
        /*background: green;*/
        object-fit: contain;
        border-radius: 0;
        padding: 0px;
        width: 70%;
        height: 61%;
    }

    .im_fechar {
        width: 25px;
        height: 25px;
        margin-left: 68px;
        margin-top: 5px;
        position: absolute;
        background: lightgray;
        border-radius: 50%;
    }
</style>


// WEBPACK FOOTER //
// src/components/mRegisterEstab.vue